import { useState, useEffect } from 'react';
import { pushNotificationService } from '../services/pushNotifications';

export const usePushNotifications = () => {
  const [pushToken, setPushToken] = useState(null);
  const [lastNotification, setLastNotification] = useState(null);
  const [isInitialized, setIsInitialized] = useState(false);
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    const initializePushNotifications = async () => {
      try {
        // Service initialisieren
        await pushNotificationService.initialize();
        
        // Callback-Funktionen setzen
        pushNotificationService.setOnTokenReceived((token) => {
          setPushToken(token);
          console.log('Push Token im Hook erhalten:', token);
        });

        pushNotificationService.setOnNotificationReceived((notification) => {
          setLastNotification(notification);
          setNotifications(prev => [notification, ...prev]);
          console.log('Neue Benachrichtigung im Hook:', notification);
        });

        pushNotificationService.setOnNotificationOpened((notification) => {
          console.log('Benachrichtigung geöffnet im Hook:', notification);
          // Hier können Sie Navigation oder andere Aktionen durchführen
        });

        setIsInitialized(true);
      } catch (error) {
        console.error('Fehler beim Initialisieren der Push Notifications im Hook:', error);
      }
    };

    initializePushNotifications();
  }, []);

  // Funktion zum Senden des Tokens an den Server
  const sendTokenToServer = async (token, userId) => {
    try {
      // Hier würden Sie den Token an Ihren Backend-Server senden
      // Beispiel-Implementation:
      // await fetch('/api/push-tokens', {
      //   method: 'POST',
      //   headers: {
      //     'Content-Type': 'application/json',
      //     'Authorization': `Bearer ${authToken}`
      //   },
      //   body: JSON.stringify({
      //     token: token,
      //     userId: userId,
      //     platform: 'mobile'
      //   })
      // });
      
      console.log('Push Token würde an Server gesendet:', { token, userId });
    } catch (error) {
      console.error('Fehler beim Senden des Push Tokens an Server:', error);
    }
  };

  // Benachrichtigung als gelesen markieren
  const markNotificationAsRead = (notificationId) => {
    setNotifications(prev => 
      prev.map(notification => 
        notification.id === notificationId 
          ? { ...notification, read: true }
          : notification
      )
    );
  };

  // Alle Benachrichtigungen löschen
  const clearAllNotifications = async () => {
    try {
      await pushNotificationService.removeAllDeliveredNotifications();
      setNotifications([]);
    } catch (error) {
      console.error('Fehler beim Löschen aller Benachrichtigungen:', error);
    }
  };

  // Gelieferte Benachrichtigungen laden
  const loadDeliveredNotifications = async () => {
    try {
      const delivered = await pushNotificationService.getDeliveredNotifications();
      return delivered;
    } catch (error) {
      console.error('Fehler beim Laden der gelieferten Benachrichtigungen:', error);
      return [];
    }
  };

  return {
    pushToken,
    lastNotification,
    notifications,
    isInitialized,
    sendTokenToServer,
    markNotificationAsRead,
    clearAllNotifications,
    loadDeliveredNotifications
  };
};
